/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import ImageLoad from '../ImageLoad';
import secureLocalStorage from 'react-secure-storage';
import Slider from "react-slick";
import { LuPlus } from "react-icons/lu";
import { HiMiniMinusSmall } from "react-icons/hi2";

const Shop = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, medicineId, setIsLoginShow } = useContext(MyContext);

    const [categoryList, setCategoryList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiLoading, setApiLoading] = useState(false);
    const [detailsShow, setDetailsShow] = useState(false);
    const [detailsData, setDetailsData] = useState([]);
    const [isShow, setisShow] = useState("");
    const [details, setDetails] = useState([]);
    const [productId, setProductId] = useState();
    const [cartData, setCartData] = useState([]);

    const navigate = useNavigate();
    const LoadingRef = useRef(false);

    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const settings2 = {
        arrows: false,
        dots: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const customer_id = secureLocalStorage.getItem("Userid");
        axios.post(`${ApiBaseUrl}/customer/customer_category_list`, { customer_id })
            .then((res) => {
                if (res.data.ResponseCode === 200) {
                    setLoading(false);
                    setCategoryList(res.data.category_list);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    useEffect(() => {
        if (!medicineId) return;
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        setApiLoading(true);
        setDetailsShow(true);
        axios.post(`${ApiBaseUrl}/customer/product_detail`, { uid: Userid, doctor_id: medicineId?.store_id, prod_id: medicineId?.id })
            .then((res) => {
                // console.log("product_detail", res);
                setDetailsData([res.data.product]);
                setApiLoading(false);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [medicineId]);

    const HandleNavigate = (id) => {
        navigate("/shop-list");
        sessionStorage.setItem("Catid", id);
    }

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    const HandleShowPriceDetails = (e, items, index) => {
        e.stopPropagation();
        setDetailsShow(false);
        setProductId(items.id);
        setisShow({ name: items.product_name, img: index === 1 ? items.product_image[0] : items.product_image });
        setDetails(items.price_detail);
        const Data = { id: items.id, price_detail: items.price_detail };
        setCartData([...cartData, Data]);
    };

    return (
        <div className='w-full width-container pb-[50px] content-wrapper'>
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="">
                    <div className="ourservices mt-[20px]">
                        <h1 className='d-title'>{t("Shop by Categories")}</h1>
                        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 mt-[20px]">
                            {categoryList.map((item, index) => {
                                return <div onClick={() => HandleNavigate(item.id)} key={index} className='h-full md:h-[200px] rounded-[15px] border cursor-pointer border-gray-200 hover:border-[#4038FF] hover:shadow-md hover:-translate-y-1 transition-all duration-300 p-[10px] flex flex-col justify-center'>
                                    <ImageLoad src={ImgBaseUrl + item.image} CustomeStyle={"w-[100%] h-[100px] md:h-[120px] object-contain mx-auto rounded-[10px]"} alt={"logo"} />
                                    <h1 className='font-[500] mt-[15px] text-center whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.name}</h1>
                                </div>
                            })}
                        </div>
                    </div>
                </div>}


            {detailsShow && <div onClick={() => setDetailsShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[700px] scroll-container">
                    {apiLoading
                        ? <Loading CustomeStyle="w-full h-[500px] flex items-center justify-center" />
                        : <div className="">
                            {detailsData.map((item, index) => {
                                const singleLineText = item?.description.replace(/\r\n|\r|\n/g, '<br />');
                                const TotalCart = item.price_detail.reduce((acc, curr) => acc + curr.cart_qty, 0);
                                return <div key={index} className="">
                                    <div key={index} className="slider-container mb-[20px]">
                                        <Slider {...settings2}>
                                            {
                                                item.product_image.map((item, index) => {
                                                    return <div key={index} className='outline-none'>
                                                        <ImageLoad src={ImgBaseUrl + item} CustomeStyle={"h-[300px] object-contain w-[100%] px-1 rounded-[20px]"} alt={"Slider Img"} />
                                                    </div>
                                                })
                                            }
                                        </Slider>
                                    </div>
                                    <div className="mt-[10px]">
                                        {item.prescription_require === "Required" && <h1 className='font-[500] text-red-700'>{t("Prescription Required")}</h1>}
                                        <h1 className='font-[500] text-[18px]'>{item.product_name}</h1>
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-[10px]">
                                                <h1 className='font-[500] text-[18px]'>{currency}{item.price_detail[0].price}</h1>
                                                <span className='line-through text-gray-500'>{currency}{item.price_detail[0].base_price}</span>
                                                {item.price_detail[0].discount !== 0 && <h1 className='bg-orange-400 text-white px-[10px] rounded-[50px] text-[14px] font-[500]'>{item.price_detail[0].discount}% OFF</h1>}
                                            </div>
                                            <div className="text-center">
                                                <button onClick={(e) => HandleShowPriceDetails(e, item, 1)} className='border-[1px] border-[#4038FF] text-[#4038FF] font-[500] text-[18px] rounded-[10px] py-[2px]'>
                                                    {TotalCart
                                                        ? <div className="flex items-center px-[5px] gap-[10px]">
                                                            <HiMiniMinusSmall />
                                                            <h1>{TotalCart}</h1>
                                                            <LuPlus />
                                                        </div>
                                                        : <h1 className='px-[20px]'>{t("Add")}</h1>}
                                                </button>
                                                <h1 className='text-[#4038FF]'>{item.price_detail.length} {t("Option")}</h1>
                                            </div>
                                        </div>
                                        <span className='text-[18px]'>Unit</span>
                                        <p className='text-gray-500' dangerouslySetInnerHTML={{ __html: singleLineText }} />
                                    </div>
                                </div>
                            })}
                        </div>}
                </div>
            </div>}


            {isShow && <div onClick={() => setisShow("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[650px] scroll-container">
                    <div className="flex items-center justify-between">
                        <h1 className='font-[500] text-[20px] mb-[5px]'>{isShow.name}</h1>
                        <button onClick={() => setisShow("")}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                            </svg>
                        </button>
                    </div>
                    {details.map((item, index) => {
                        return <DetailsSheet key={index} item={item} isShow={isShow} ImgBaseUrl={ImgBaseUrl} currency={currency} LoadingRef={LoadingRef} setisShow={setisShow} setIsLoginShow={setIsLoginShow} Docid={medicineId?.store_id} productId={productId} details={details} ApiBaseUrl={ApiBaseUrl} setDetails={setDetails} />
                    })}
                    <button onClick={() => setisShow("")} className='payment-btn mt-[10px]'>{t("Done")}</button>
                </div>
            </div>}

        </div>
    )
}

export default Shop
/* jshint ignore:end */

const DetailsSheet = ({ item, isShow, ImgBaseUrl, currency, LoadingRef, setisShow, setIsLoginShow, Docid, productId, details, ApiBaseUrl, setDetails }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);

    const handleAddToCart = (item) => {

        const Userid = secureLocalStorage.getItem("Userid");

        if (LoadingRef.current) {
            return;
        }

        if (!Userid) {
            setisShow("");
            setIsLoginShow(true);
            return;
        }

        setLoading(true);
        LoadingRef.current = true;

        const payload = {
            uid: Userid,
            doctor_id: Docid,
            prod_id: productId,
            pro_price: item.price,
            pro_ptype: item.title,
            pro_qty: item.cart_qty,
            pro_qty_type: 1,
            mode: 1,
        };

        const updatedDetails = details.map(detail =>
            detail.title === item.title
                ? { ...detail, cart_qty: detail.cart_qty + 1 }
                : detail
        );

        axios.post(`${ApiBaseUrl}/customer/cart_detail`, payload)
            .then((response) => {
                // console.log(response);
                setLoading(false);
                LoadingRef.current = false;
                setDetails(updatedDetails);
            })
            .catch((error) => {
                console.error('Failed to add item to cart:', error);
            });
    };

    const handleRemoveToCart = (item) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (LoadingRef.current) {
            return;
        }

        if (Userid) {

            setLoading(true);
            LoadingRef.current = true;

            const Data = {
                uid: Userid,
                doctor_id: Docid,
                prod_id: productId,
                pro_price: item.price,
                pro_ptype: item.title,
                pro_qty: item.cart_qty,
                pro_qty_type: 2,
                mode: 1
            };

            const updatedDetails = details.map(detail =>
                detail.title === item.title
                    ? { ...detail, cart_qty: detail.cart_qty - 1 }
                    : detail
            );

            axios.post(`${ApiBaseUrl}/customer/cart_detail`, Data)
                .then((res) => {
                    // console.log(res);
                    setLoading(false);
                    LoadingRef.current = false;
                    setDetails(updatedDetails);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    return <div className="border-t-[1px] border-[#8080803b] py-[8px]">
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-[10px]">
                <ImageLoad src={ImgBaseUrl + isShow.img} CustomeStyle={"border-[1px] border-[#8080803b] rounded-[10px] w-[80px] h-[80px] object-cover"} alt={"img"} />
                <div className="leading-[22px]">
                    <h1 className='font-[500] text-[17px]'>{isShow.name}</h1>
                    <span className='text-gray-500'>{item.title}</span>
                    <div className="flex items-center gap-[10px]">
                        <h1 className='font-[500] text-[18px]'>{currency}{item.price}</h1>
                        <span className='line-through text-gray-500'>{currency}{item.base_price}</span>
                        <h1 className='bg-orange-400 text-white px-[10px] rounded-[50px] text-[14px] font-[500]'>{item.discount}% OFF</h1>
                    </div>
                </div>
            </div>
            <div className='border-[1px] border-[#4038FF] text-[#4038FF] font-[500] text-[18px] rounded-[10px] py-[2px]'>
                {loading
                    ? <div className="px-[25px] py-[2px]">
                        <div className="loader2"></div>
                    </div>
                    : item.cart_qty
                        ? <div className="flex items-center px-[5px] gap-[10px]">
                            <button onClick={() => handleRemoveToCart(item)}><HiMiniMinusSmall /></button>
                            <h1>{item.cart_qty}</h1>
                            <button onClick={() => handleAddToCart(item)} ><LuPlus /></button>
                        </div>
                        : <button onClick={() => handleAddToCart(item)} className='px-[20px]' >{t("Add")}</button>}
            </div>
        </div>
    </div>
}